import React, { useContext, useEffect, useReducer } from 'react';
import { changeComboGroupPositionReducer } from './changeComboGroupPositionReducer';
import { ChangeComboGroupPositionActionTypes } from './changeComboGroupPositionActions';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeComboGroupPositionContext,
	changeComboGroupPositionInitialState,
	TChangeComboGroupPositionSelectedItem,
	TTypeOfChangeComboGroupPositionModalWindow,
} from './changeComboGroupPositionContext';
import { IComboGroupPositionItem, IGetComboGroupPositionList, IUpdateComboGroupPositions } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getComboGroupPositionList } from 'backend/comboGroups';

const ChangeComboGroupPositionState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(changeComboGroupPositionReducer, changeComboGroupPositionInitialState);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { response, loading, refetch } = useFetchData<IGetComboGroupPositionList, string>(
		state.IDSelectedDish ? getComboGroupPositionList : null,
		state.IDSelectedDish || '',
	);

	useEffect(() => {
		refetch();
	}, [state.IDSelectedDish]);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		response &&
			dispatch({
				type: ChangeComboGroupPositionActionTypes.SET_POSITIONS_DATA,
				payload: {
					positionsData: response.data.comboGroupPositions,
				},
			});
	}, [response]);

	const setIDCustomer = (value: TChangeComboGroupPositionSelectedItem) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.SET_ID_CUSTOMER,
			payload: {
				IDSelectedCustomer: value,
			},
		});
	};

	const setIDRestaurant = (value: TChangeComboGroupPositionSelectedItem) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.SET_ID_RESTAURANT,
			payload: {
				IDSelectedRestaurant: value,
			},
		});
	};

	const setIDDish = (value: TChangeComboGroupPositionSelectedItem) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.SET_ID_DISH,
			payload: {
				IDSelectedDish: value,
			},
		});
	};

	const resetSelectedControls = () => dispatch({ type: ChangeComboGroupPositionActionTypes.RESET_SELECTED_CONTROLS });

	const setPositionsData = (value: IComboGroupPositionItem[]) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.SET_POSITIONS_DATA,
			payload: {
				positionsData: value,
			},
		});
	};

	const reorderItems = (value: IComboGroupPositionItem[]) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.REORDER_ITEMS,
			payload: {
				newOrder: value,
			},
		});
	};

	const setDataForSubmit = (value: IUpdateComboGroupPositions | null) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	};

	const changeTypeOfModalWindow = (value: TTypeOfChangeComboGroupPositionModalWindow) => {
		dispatch({
			type: ChangeComboGroupPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	};

	return (
		<ChangeComboGroupPositionContext.Provider
			value={{
				setIDCustomer,
				setIDRestaurant,
				setIDDish,
				resetSelectedControls,
				setPositionsData,
				reorderItems,
				setDataForSubmit,
				changeTypeOfModalWindow,
				IDSelectedCustomer: state.IDSelectedCustomer,
				IDSelectedRestaurant: state.IDSelectedRestaurant,
				IDSelectedDish: state.IDSelectedDish,
				positionsData: state.positionsData,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</ChangeComboGroupPositionContext.Provider>
	);
};

export default ChangeComboGroupPositionState;
